export const getApiFieldListForIPSA = (body, form, listSkinCheckupProducts) => {
  let newBody = {};
  let triggerType = body.triggerType;

  if (
    triggerType === "IPSA_BIRTHDAY" ||
    triggerType === "IPSA_WELCOME_2" ||
    triggerType === "IPSA_WELCOME_3" ||
    triggerType === "IPSA_THANK_YOU_(EXISTING)_WITH_PURCHASE" ||
    triggerType === "IPSA_LEAD_CUSTOMERS"
  ) {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
    };
  } else if (triggerType === "IPSA_WELCOME_1") {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      billType: form.billType,
    };
  } else if (
    triggerType === "IPSA_SKIN_CHECKUP" ||
    triggerType === "IPSA_PROSPECT"
  ) {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      productParentCodes: listSkinCheckupProducts.map((p) => p.productCode),
    };
  } else if (triggerType === "IPSA_PRE_LAPSED") {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      monthPeriod: form.monthPeriod,
    };
  }
  return newBody;
};

export const getApiFieldListForNARS = (body, form) => {
  let newBody = {};
  let triggerType = body.triggerType;

  if (
    triggerType === "NARS_BIRTHDAY" ||
    triggerType === "NARS_WELCOME_WITHOUT_PURCHASE" ||
    triggerType === "NARS_THANK_YOU_(EXISTING)_WITH_PURCHASE" ||
    triggerType === "NARS_LEAD_CUSTOMERS"
  ) {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
    };
  } else if (triggerType === "NARS_PRE_LAPSED") {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      monthPeriod: form.monthPeriod,
    };
  } else if (triggerType === "NARS_TOUCH_3_AND_4") {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      afterFirstBillDayPeriod: form.afterFirstBillDayPeriod,
      isWithPurchase: form.isWithPurchase,
      isWithoutPurchase: form.isWithoutPurchase,
    };
  } else if (triggerType === "NARS_TOUCH_2") {
    newBody = {
      ...body,
      byCategoriesMessageTemplates: form.byCategoriesMessageTemplates,
    };
  } else if (triggerType === "NARS_TOUCH_1") {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      hasTop40Products: form.hasTop40Products,
      top40ProductsTempFilePath: form.top40ProductsTempFilePath,
    };
  }
  return newBody;
};

export const getApiFieldListForShiseido = (body, form) => {
  let newBody = {};
  let triggerType = body.triggerType;

  if (triggerType === "Shiseido FIRST WELCOME") {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      billType: form.billType,
    };
  } else if (triggerType === "Shiseido TOUCH 1 AND 2") {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      afterFirstBillDayPeriod: form.afterFirstBillDayPeriod,
    };
  } else if (triggerType === "Shiseido PRE LAPSED AND LAPSED") {
    newBody = {
      ...body,
      monthNotPurchasePeriod: form.monthNotPurchasePeriod,
      minTotalPurchase: form.minTotalPurchase,
      messageTemplatesForHv: form.messageTemplatesForHv,
      messageTemplatesForLv: form.messageTemplatesForLv,
    };
  } else if (triggerType === "Shiseido REPLENISHMENT") {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      daysAfterLastPurchase: form.daysAfterLastPurchase,
    };
  } else if (triggerType === "Shiseido PROMISE YOU") {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      afterFirstBillDayPeriod: form.afterFirstBillDayPeriod,
      purchaseSfsLx: form.purchaseSfsLx,
    };
  } else if (triggerType === "Shiseido BIRTHDAY") {
    newBody = {
      ...body,
      minimumSpendingSfsLxHv: form.minimumSpendingSfsLxHv,
      messageTemplatesForSfsLxHv: form.messageTemplatesForSfsLxHv,
      minimumSpendingSfsLxLv: form.minimumSpendingSfsLxLv,
      messageTemplatesForSfsLxLv: form.messageTemplatesForSfsLxLv,
      minimumSpendingNonSfsLxHv: form.minimumSpendingNonSfsLxHv,
      messageTemplatesForNonSfsLxHv: form.messageTemplatesForNonSfsLxHv,
      minimumSpendingNonSfsLxLv: form.minimumSpendingNonSfsLxLv,
      messageTemplatesForNonSfsLxLv: form.messageTemplatesForNonSfsLxLv,
      messageTemplatesForAnyPurchase: form.messageTemplatesForAnyPurchase,
    };
  } else if (
      triggerType === "Shiseido THANK YOU (EXISTING) WITH PURCHASE" ||
      triggerType === "Shiseido LEAD CUSTOMERS"
  ) {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
    };
  }
  return newBody;
};

export const getApiFieldListForCPB = (body, form) => {
  let newBody = {};
  let triggerType = body.triggerType;

  if (
    triggerType === "CPB WELCOME (NO PURCHASE) & THANK YOU (NEW) WITH PURCHASE"
  ) {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      billType: form.billType,
    };
  } else if (triggerType === "CPB REPLENISHMENT & TOUCH I & TOUCH II") {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      daysAfterLastPurchase: form.daysAfterLastPurchase,
    };
  } else if (
    triggerType === "CPB PROSPECT CONVERSION & NEW MEMBER CULTIVATION"
  ) {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      billType: form.billType,
      daysAfterFirstBill: form.daysAfterFirstBill,
    };
  } else if (triggerType === "CPB BIRTHDAY") {
    newBody = {
      ...body,
      byMembershipMessageTemplates: form.byMembershipMessageTemplates,
    };
  } else if (
      triggerType === "CPB THANK YOU (EXISTING) WITH PURCHASE" ||
      triggerType === "CPB LEAD CUSTOMERS"
  ) {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
    };
  } else if (triggerType === "CPB PRE LAPSED AND LAPSED") {
    newBody = {
      ...body,
      monthNotPurchasePeriod: form.monthNotPurchasePeriod,
      minTotalPurchase: form.minTotalPurchase,
      messageTemplatesForHv: form.messageTemplatesForHv,
      messageTemplatesForLv: form.messageTemplatesForLv,
    };
  }
  return newBody;
};

export const getApiFieldListForDE = (body, form) => {
  let newBody = {};
  let triggerType = body.triggerType;

  if (triggerType === "DE PRE LAPSED AND LAPSED") {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      monthPeriod: form.monthPeriod,
    };
  } else if (triggerType === "DE REPLENISHMENT") {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      daysAfterLastPurchase: form.daysAfterLastPurchase,
    };
  } else if (
    triggerType === "DE BIRTHDAY" ||
    triggerType === "DE THANK YOU (EXISTING) WITH PURCHASE" ||
    triggerType === "DE LEAD CUSTOMERS"
  ) {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
    };
  } else if (
    triggerType === "DE PROSPECT CONVERSION & NEW MEMBER CULTIVATION"
  ) {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      billType: form.billType,
      daysAfterFirstBill: form.daysAfterFirstBill,
    };
  } else if (
    triggerType === "DE WELCOME (NO PURCHASE) & THANK YOU (NEW) WITH PURCHASE"
  ) {
    newBody = {
      ...body,
      messageTemplates: form.messageTemplates,
      billType: form.billType,
    };
  }
  return newBody;
};

const sharedApiFieldForSFAndEIConfig = {
  "WELCOME (NO PURCHASE) & THANK YOU (NEW) WITH PURCHASE": {
    fields: ["messageTemplates", "billType"],
  },
  "PROSPECT CONVERSION & NEW MEMBER CULTIVATION": {
    fields: ["messageTemplates", "billType", "daysAfterFirstBill"],
  },
  BIRTHDAY: {
    fields: ["messageTemplates"],
  },
  "THANK YOU (EXISTING) WITH PURCHASE": {
    fields: ["messageTemplates"],
  },
  REPLENISHMENT: {
    fields: ["messageTemplates", "daysAfterLastPurchase"],
  },
  "PRE LAPSED AND LAPSED": {
    fields: ["messageTemplates", "monthPeriod"],
  },
  "LEAD CUSTOMERS": {
    fields: ["messageTemplates"],
  },
};

export const getApiFieldListForSFOrEI = (body, form) => {
  let newBody = {};
  const triggerType = body.triggerType;

  const [prefix, ...rest] = triggerType.split(" ");
  const key = rest.join(" ");

  if (prefix === "SF" || prefix === "EI") {
    const config = sharedApiFieldForSFAndEIConfig[key];

    if (config) {
      newBody = {
        ...body,
        ...config.fields.reduce((acc, field) => {
          acc[field] = form[field];
          return acc;
        }, {}),
      };
    }
  } else {
    console.warn(`Unknown trigger type: ${triggerType}`);
  }

  return newBody;
};
